var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortalMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 120,
    viewBox: "0 0 243 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19899_1161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-140.694 -131.309C-121.673 -161.779 -14.2944 -160.18 45.0123 -151.191C104.319 -142.203 278.767 24.1451 306.834 62.3086C268.194 80.8914 275.651 97.8346 220.064 108.766C163.818 119.826 129.477 85.3076 56.2648 79.7983C-16.9472 74.2891 -54.7653 133.628 -95.1545 90.7294",
    fill: "url(#paint0_linear_19899_1161)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19899_1161",
    x: -144.894,
    y: -156.884,
    width: 455.927,
    height: 276.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19899_1161"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19899_1161",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19899_1161",
    x1: -27.1156,
    y1: 64.1286,
    x2: 223.571,
    y2: 144.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2AC6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#339FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortalMarketplace);
export default __webpack_public_path__ + "static/media/portal_marketplace.59bda87c6e50c1587e971b9e2b8a68a7.svg";
export { ForwardRef as ReactComponent };